import { render, staticRenderFns } from "./country.vue?vue&type=template&id=5a891ff0"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a891ff0')) {
      api.createRecord('5a891ff0', component.options)
    } else {
      api.reload('5a891ff0', component.options)
    }
    module.hot.accept("./country.vue?vue&type=template&id=5a891ff0", function () {
      api.rerender('5a891ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/tcSetting/country.vue"
export default component.exports